module.exports = __webpack_public_path__ + "static/img/isclanjenje2.2760bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/isclanjenje2.png
// module id = yFaJ
// module chunks = 0